<template>
  <div class="columns is-mobile">
    <div class="column">
      <b-field
        label="Policy Number"
        :type="{'is-danger': errors.has('policy.policynumber')}"
        :message="errors.first('policy.policynumber')"
      >
        <b-input
          type="is-success"
          v-model="polNumber"
          name="policynumber"
          v-validate="'numeric|min:8'"
          data-vv-as="Policy Number"
          data-vv-scope="policy"
          maxlength="8"
        />
      </b-field>
      <b-field
        label="State"
        :type="{'is-danger': errors.has('policy.state')}"
        :message="errors.first('policy.state')"
      >
        <b-select
          v-model="policy.state"
          placeholder="Please select"
          name="state"
          v-validate="'required'"
          data-vv-as="State"
          data-vv-scope="policy"
        >
          <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
        </b-select>
      </b-field>
      <b-field
        label
        :type="{'is-danger': errors.has('policy.flag-terms')}"
        :message="{'Please check this box to proceed' : errors.first('flag-terms', 'required')}"
        v-if="message.displaynp"
      >
        <b-checkbox
          v-model="policy.npAgreement"
          name="flag-terms"
          data-vv-scope="policy"
          v-validate="'required:false'"
        >
          <!-- <b-message title type="is-danger" aria-close-label="Close message"> -->
          We
          <u>could not</u> verify the policy information you provided.
          Please select check box to agree and click [Next] to continue to file a claim without
          a policy number or
          you may contact Republic Indemnity claim Reporting at (800) 821-4520
          <!-- </b-message> -->
        </b-checkbox>
      </b-field>
      <b-notification
        :active.sync="message.displaynp && !policy.npAgreement"
        type="is-danger"
        aria-close-label="NP Agreement notification"
        role="alert"
      >Please accept agreement before proceeding.</b-notification>
    </div>
  </div>
</template>
<script>
import TypeLists from "../data/typelists";
import { ValidatePublicPolicy } from "../utils/services";

export default {
  props: ["policy", "message", "injurydate"],
  name: "PolicyInfo",
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator;
  },
  data() {
    return {
      polNumber: "",
      stateMap: TypeLists.StatesFiltered
    };
  },
  watch: {
    polNumber: function(val) {
      this.policy.policyNumber = val;
      var params = {
        injurydate: this.injurydate,
        policynbr: this.policy.policyNumber
      };
      if (val.length == 8) {
        ValidatePublicPolicy(params)
          .then(res => {
            if (res.status == 200) {
              this.message.displaynp = false;
              this.policy.npAgreement = false;
            } else {
              this.message.displaynp = true;
            }
          })
          .catch(err => {
            //alert(err);
            this.message.displaynp = true;
          });
      }
    }
  }
};
</script>

